import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import {
  Box,
  DialogActions,
  Grid,
  Link,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useSelector } from "react-redux";

import useStyles from "../styles";
import { DialogContent, DialogTitle } from "components/common/DialogApi";
import securityActions from "../actions";
import { AppRouteURI } from "router/RoleBasedAccess";
import Transition from "components/common/Transition";

const ResetPassword = () => {
  const classes = useStyles();
  const { isPwdResetDialogOpen } = useSelector((state) => state.security);
  const { setPwdRstDialogOpen } = securityActions();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <Dialog
      fullScreen={!matches}
      TransitionComponent={Transition}
      disableBackdropClick
      open={isPwdResetDialogOpen}
      maxWidth="sm"
      aria-labelledby="reset-dialog"
    >
      <DialogTitle id="reset-dialog" onClose={() => setPwdRstDialogOpen(false)}>
        <Grid container justify="center">
          <Typography variant="h5">Password reset</Typography>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Box className={classes.dialogContent}>
          <Typography variant="body2">
            All SVP members (including yourself and all admins) will be
            immediately signed out from SVP. Members will be promoted for new
            passwords via email before they can sign in again.
          </Typography>
          <Typography className={classes.content} variant="body2">
            To reset individual passwords, go to their
          </Typography>
          <Typography variant="body2">
            <Link underline="always" href={AppRouteURI.MEMBERS} color="inherit">
              Member Profile
            </Link>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth={!matches}
          variant="outlined"
          color="secondary"
          onClick={() => setPwdRstDialogOpen(false)}
        >
          Cancel
        </Button>
        <Button fullWidth={!matches} variant="contained" color="primary">
          Reset Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPassword;
